import MobileBolao from '../MobileBolao';
import { JogoPlacarHeader } from './JogoPlacarHeader';
import { AiPreviewCard, EscalacaoCard, FunFactsCard } from './JogoSharedCards';
import type { FutebolPartidaAtiva, FutebolJogoDia } from '@/shared/types';

interface Props {
  telaId: string;
  partida: FutebolPartidaAtiva;
  jogo: FutebolJogoDia | null;
  exibirBolao: boolean;
}

export function JogoPreJogoView({ telaId, partida, jogo, exibirBolao }: Props) {
  const nomeCasa = jogo?.time_casa      ?? '–';
  const nomeVis  = jogo?.time_visitante ?? '–';

  return (
    <>
      <div className="sticky top-0 z-20 shrink-0 bg-jukebox-bg">
        <JogoPlacarHeader partida={partida} jogo={jogo} modo="pre_jogo" />
      </div>

      <div className="px-4 pt-4 pb-24 space-y-4 flex-1">
        {exibirBolao && partida.fixture_id != null && (
          <MobileBolao
            telaId={telaId}
            fixtureId={partida.fixture_id}
            tempoJogo={partida.tempo_jogo}
            nomeCasa={jogo?.time_casa ?? undefined}
            nomeVisitante={jogo?.time_visitante ?? undefined}
            escudoCasa={jogo?.escudo_casa ?? undefined}
            escudoVisitante={jogo?.escudo_visitante ?? undefined}
          />
        )}

        {partida.ai_preview && <AiPreviewCard text={partida.ai_preview} />}
        {partida.lineup && partida.lineup.status !== 'unavailable' && (
          <EscalacaoCard lineup={partida.lineup} nomeCasa={nomeCasa} nomeVisitante={nomeVis} />
        )}
        {partida.funfacts && partida.funfacts.length > 0 && (
          <FunFactsCard funfacts={partida.funfacts} />
        )}
      </div>
    </>
  );
}
